module.exports = __webpack_public_path__ + "static/img/content_img3.2e614827.png";